var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNeckTattoo = function SvgNeckTattoo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 45,
    height: 26,
    viewBox: "0 0 1.13 0.65",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.45.06C.43.22.45.24.27.29.18.31.12.32.09.41.05.5.05.57.14.57c.17 0 .33 0 .5.01.09.01.28.02.37.01.03-.01.05.01.06-.06C1.08.41 1.04.35.93.31.85.28.78.31.72.2A.373.373 0 0 1 .7.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.4.4c0 .01.18.05.18.02 0-.04-.05 0 .03 0C.64.42.68.41.7.4h0"
  }))));
};

export default SvgNeckTattoo;